import { render, staticRenderFns } from "./vaccinationCenters.vue?vue&type=template&id=12bcbcce&"
import script from "./vaccinationCenters.vue?vue&type=script&lang=js&"
export * from "./vaccinationCenters.vue?vue&type=script&lang=js&"
import style0 from "./vaccinationCenters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports